import { Component, Inject, signal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { httpsCallable } from 'firebase/functions';
import moment from 'moment';
import { dataStore, functions } from 'src/app/app.component';
import { LogType } from 'src/app/enums';
import { AutoPlanService } from 'src/app/planner/components/auto-plan/auto-plan-service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';

export interface DialogData {
  date: Date;
}

type AutoPlanResult = {
  status: string;
  unassignedRides?: number;
};

@Component({
  selector: 'app-auto-plan-dialog',
  templateUrl: './auto-plan-dialog.component.html',
  styleUrl: './auto-plan-dialog.component.scss',
  imports: [MatProgressSpinner, MatButton, MatDialogTitle, MatDialogContent, MatDialogActions],
})
export class AutoPlanDialogComponent {
  loading = signal(false);
  moment = moment;
  result = signal<AutoPlanResult | null>(null);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AutoPlanDialogComponent>,
    private autoPlanService: AutoPlanService,
  ) {}

  async planAutomaticRides() {
    this.loading.set(true);
    const organisationId =
      localStorage.getItem('orgId') ||
      dataStore.selectedOrganisation?.id ||
      dataStore.rootUser?.selectedOrgId;

    if (!organisationId) {
      console.error('Could not resolve organisationId for automatic planning.');
      this.loading.set(false);
      return;
    }

    const logId = await this.autoPlanService.createAutomaticPlanningActionLog(
      LogType.AutomaticPlanningStarted,
      this.data.date,
    );
    const callable = httpsCallable(functions, 'httpAutoPlan');
    try {
      const result = await callable({
        date: moment(this.data.date).format('YYYY-MM-DD'), //Cast date to string because of timezone issues in firebase
        organisationId,
      });
      console.log('result:', result.data);
      const autoPlanResult = result.data as AutoPlanResult;
      this.result.set(autoPlanResult);
      const status = this.autoPlanService.getAutoPlanLogStatus(autoPlanResult.status);
      await this.autoPlanService.updateAutomaticPlanningActionStatus(logId, status);
      this.loading.set(false);
    } catch (error) {
      await this.autoPlanService.updateAutomaticPlanningActionStatus(logId, 'failed');
      this.loading.set(false);
    }
  }
}
